import { SingleDataValue } from '.';
import { ThemedFlex } from '../../theme/ThemedFlex';
import { getFallbackValue } from '../../utils/fallbackCalculations';
import { useRecoilValue } from 'recoil';
import { recentBlocksState } from '../../recoilState';

export const NetworkTileBlocks24h = ({ data, blockMetrics, formatNumber, animate }) => {
  const recentBlocks = useRecoilValue(recentBlocksState);

  // Priority: blockMetrics (actual count by timestamp), then fallback calculation
  const blocks = blockMetrics?.blocks24h
    || getFallbackValue('newBlocks24h', {
      recentBlocks,
      s091: data?.s091
    });

  const numberValue = blocks != null
    ? `${formatNumber(blocks, 0)} Blocks`
    : '';

  return (
    <ThemedFlex
      direction="column"
      mb="12px"
      py="18px"
      px="20px"
      flex={1}
      borderRadius={3}
      className={animate ? 'gray-border-custom gray-border' : ''}
    >
      <SingleDataValue label="New Blocks 24h" value={numberValue} />
    </ThemedFlex>
  );
};